module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Light.e25aee1.ttf";